<template>
  <div>
    <div class="  mt-16 mb-8" dir="auto">
      <about-title page-route="" :title="$t('products')"/>
    </div>
    <div>
      <v-row no-gutters style="direction: rtl;" v-if="showProducts" :key="productsKey">
        <v-col
            @mouseover="showHover=i"
            @mouseleave="showHover=null"
            class="p-column"
            v-for="(product,i) in products"
            :key="i"
            cols="12"
            lg="3"
            xl="3">

          <v-img

              class="p-col"
              :gradient="showHover===i?'to right top, rgb(18 27 222 / 66%), rgb(17 17 216 / 63%)':' to top right, rgb(4 4 4 / 33%), rgb(4 4 4 / 33%)'"
              :src="product.photo_file"
              width="100%"
              height="700"
              transition="fade"

          >
            <h2 class="white--text pointer">{{ product.title }}</h2>
            <ul class="p-items">
              <li class="w-80 ma-auto mt-3 mr-16 d-flex align-start justify-start" v-for="(children,i) in product.sub"
                  :key="i">
                <div class="d-flex  sub-style" @click="$router.push('/sub/glass/single/'+children.id)">
<!--                  <v-icon class="icon-style">{{ children.icon }}</v-icon>-->
                  <h5 class="child-style pointer">{{ children.title }}</h5>
                </div>
              </li>
            </ul>

          </v-img>
        </v-col>
      </v-row>
      <loading v-else />
    </div>
  </div>
</template>
<script>
import AboutTitle from "../../material/pages/About/Components/AboutTitle";
import {mapState} from "vuex";
import { getApi } from "../../../../data/ApiService";
export default {
  name: 'mainGlassProducts',
  components: {AboutTitle},
  data() {
    return {
      productsKey:0,
      showHover: null,
      selectedIndex: 0,
      top: 0,
      down: 3,
      floute:[],
      high_performance:[],
      industrial:[],
      building:[],
      products:[],
      showProducts:false
    }
  },
  computed:{
    
  },
  watch:{
    async "$store.state.glassManagement.products"(){
      this.products=this.$store.state.glassManagement.products;
      for(const index in this.products){
        let {data}=await getApi(`category/${this.products[index].id}/page/1/count/100`)
        this.products[index].sub=data.topics;
      }
      this.showProducts=true
      this.productsKey++;
      // const {data:building}=await getApi("category/20/page/1/count/100")
      // this.building=building.topics;
      // const {data:industrial}=await getApi("category/114/page/1/count/100")
      // this.industrial=industrial.topics;
      // const {data:high_performance}=await getApi("category/117/page/1/count/100")
      // this.high_performance=high_performance.topics;
    }
  },
  methods: {},
  async created(){
    
  }

}
</script>
<style scoped>
ul {
  margin-top: 10px;
}

li {
  margin: 8px 40px;
}

.p-col {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.p-col:hover {
  padding-top: 30%;
  align-items: start;
  transition: all 0.6s;
  /*opacity: .4;*/
  /*mix-blend-mode: color;*/
  /*background-image: linear-gradient(to right top, rgb(16 47 249 / 81%), rgba(4, 4, 4, 0.33)) !important;*/
  z-index: 1;
}

.p-col:hover .p-items {
  display: flex;
}

.p-items {
  display: none;
  flex-flow: column;
  align-items: center;
  justify-content: center;
}

.child-style {
  color: rgba(255, 255, 255, 0.7);
}

.icon-style {
  margin-left: 12px;
  color: rgba(255, 255, 255, 0.7);
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.7);
}

.sub-style {
  text-decoration: none;
  color: white;
}

.sub-style:hover > * {
  color: black;
}
</style>
